import * as MuiButtonGroup from "@material-ui/core/ButtonGroup";
import * as MuiIconButton from "@material-ui/core/IconButton";
import type { Theme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";

// @ts-expect-error TS(2322) FIXME: Type 'ComponentType<Pick<{ color?: Color | undefin... Remove this comment to see the full error message
export const GroupButton: React.ComponentType<MuiIconButton.IconButtonProps> = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.primary.dark,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.paper,
    },
  },
}))(MuiIconButton.default);

const ButtonGroup: React.ComponentType<MuiButtonGroup.ButtonGroupProps> = withStyles((theme: Theme) => ({
  root: {
    height: "35px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 20,
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
}))(MuiButtonGroup.default);

export default ButtonGroup;
